/**
 * Management console routes.
 *
 * Mounted under /hr, so the paths below resolve to /hr/management/*.
 *
 * These screens show whole-company salary. The mega-menu hides the group from
 * anyone who is not an administrator (hrMenuConfig `adminOnly`), but that is a
 * convenience rather than a control: the routes remain reachable by typing the
 * URL, and the API will still answer. Real enforcement belongs on the server,
 * in ManagementController, before this is used with live staff data.
 */
export const managementRoutes: any[] = [
  {
    path: 'management',
    name: 'hrManagement',
    redirect: { name: 'managementOverview' },
    meta: {
      title: 'routes.management',
      requiresAuth: true,
      breadcrumb: 'Management',
    },
    children: [
      {
        path: 'overview',
        name: 'managementOverview',
        component: () => import('@/modules/hr/management/components/ManagementOverview.vue'),
        meta: {
          title: 'routes.managementOverview',
          requiresAuth: true,
          breadcrumb: 'Executive Summary',
        },
      },
      {
        path: 'salary-comparison',
        name: 'managementSalaryComparison',
        component: () => import('@/modules/hr/management/components/SalaryComparison.vue'),
        meta: {
          title: 'routes.managementSalaryComparison',
          requiresAuth: true,
          breadcrumb: 'Salary Comparison',
        },
      },
      {
        path: 'increments',
        name: 'managementIncrements',
        component: () => import('@/modules/hr/management/components/IncrementRound.vue'),
        meta: {
          title: 'routes.managementIncrements',
          requiresAuth: true,
          breadcrumb: 'Increment Round',
        },
      },
      {
        path: 'cost-structure',
        name: 'managementCostStructure',
        component: () => import('@/modules/hr/management/components/CostStructure.vue'),
        meta: {
          title: 'routes.managementCostStructure',
          requiresAuth: true,
          breadcrumb: 'Cost Structure',
        },
      },
    ],
  },
]
